import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/authService';
import UatTermsGate from './UatTermsGate';

function ProtectedRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // UAT-ONLY (public-testing branch): testers must e-sign the test-environment
  // notice before the application will render. This is the one pre-existing file
  // the UAT-only change touches, and it is here rather than in App.js because
  // ProtectedRoute is what both layout tiers wrap — so this covers the whole
  // authenticated surface, including /select-agency, without editing any route JSX.
  // Not present on main; drop this wrapper if these lines ever reach a product PR.
  return <UatTermsGate>{children}</UatTermsGate>;
}

export default ProtectedRoute;
